import React from "react"
import { H4 } from "@carrotfertility/carotene"
import { Spacer } from "../../atoms/Atoms"
import { NotSmall, Small } from "../../atoms/Responsive"
import { NavIcon } from "./NavItem"

export const NavSection = ({ iconName, sectionLabel, children }) => (
  <div>
    <NavIcon iconName={iconName} />
    <div className="flex">
      <Spacer width={2} />
      <H4 variant="primary">{sectionLabel}</H4>
    </div>
    <Small>
      <Spacer height={0.75} />
    </Small>
    <NotSmall>
      <Spacer height={1} />
    </NotSmall>
    {children}
    <Spacer height={1.5} />
  </div>
)
